import { ModuloArmario } from './../../models/locker.model';
import { ModulesFormComponent } from '../modules-form/modules-form.component';
import { Locker } from 'src/app/models/locker.model';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Site } from 'src/app/models/site.model';
import { Enum } from 'src/app/models/enum.model';

@Component({
    selector: 'app-lockers-form-component',
    templateUrl: './lockers-form.component.html'
})
export class LockersFormComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridView: any[] = [];
    public listItemsLocais: Array<Site> = [];
    public listItemsModelos: Array<Enum> = [];
    public formValue: Locker = {
        id: 0,
        nomeLocal: '',
        refLocal: 0,
        refModeloArmario: 0,
        nomeModeloArmario: '',
        numeroDeSerie: '',
        nome: '',
        dimensaoTotal: '',
        numeroUtilDeCacifos: '',
        modulos: []
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private dialogService: DialogService, private notificationService: NotificationService, public override dialog: DialogRef, private intl: IntlService, private api: ApiService) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');
        this.api
            .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
            .then((data) => {
                this.listItemsLocais = data.value;
            })
            .catch((err) => { });
        this.api
            .getRequest<BaseHttpResponse<Enum[]>>("Armario/GetModelos")
            .then((data) => {
                this.listItemsModelos = data.value;
            })
            .catch((err) => { });
    }

    ngOnInit(): void {
        this.setFormValues();
    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public setFormValues() {
        this.formGroup = new FormGroup({
            nome: new FormControl(this.formValue?.nome, [Validators.required]),
            refLocal: new FormControl(this.formValue.refLocal != 0 ? {
                nome: "",
                id: this.formValue.refLocal,
            } : undefined, [Validators.required]),
            refModeloArmario: new FormControl({ id: this.formValue?.refModeloArmario }),
            numeroDeSerie: new FormControl(this.formValue?.numeroDeSerie, [Validators.required]),
        });
        this.gridView = this.formValue?.modulos;
    }

    public saveChanges(): void {
        this.formGroup.markAllAsTouched();
        this.formValue.nome = this.formGroup.controls['nome'].value;
        this.formValue.refLocal = this.formGroup.controls['refLocal'].value.id;
        this.formValue.numeroDeSerie = this.formGroup.controls['numeroDeSerie'].value;
        this.formValue.refModeloArmario = this.formGroup.controls['refModeloArmario'].value.id;
        this.api.save<BaseHttpResult>('Armario/SaveArmario', this.formValue).then(res => {
            if (res.ok) {
                this.notificationService.show({
                    content: this.customMsgService.translate('registoGravadoComSucesso'),
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'bottom' },
                    type: { style: 'success', icon: true },
                    hideAfter: 2000
                });
                this.dialog.close();
            } else {
            }
        });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    arrayRemove(arr: any[], value: any) {
        alert('xpto');
        return arr.filter(function (ele) {
            return ele != value;
        });
    }

    public deleteModelo(m: any): void {
        var sim = this.customMsgService.translate('yes');
        var nao = this.customMsgService.translate('no');
        const dialog: DialogRef = this.dialogService.open({
            appendTo: this.container,
            title: this.customMsgService.translate('confirmacao'),
            content: this.customMsgService.translate('desejaRemover'),
            actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
            width: 450,
            height: 200,
            minWidth: 250,
        });

        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
            } else if (result.text == sim) {
                if (m.id != 0) {
                    this.api.getRequest<BaseHttpResult>('Armario/RemoveModulo?idModulo=' + m.id).
                        then(res => {
                            if (res.ok) {
                                this.formValue.modulos = this.formValue.modulos.filter((obj) => { return obj.internalID !== m.internalID; });
                                this.gridView = this.formValue.modulos;
                                this.notificationService.show({
                                    appendTo: this.container,
                                    content: this.customMsgService.translate('registoApagadoComSucesso'),
                                    animation: { type: 'slide', duration: 500 },
                                    position: { horizontal: 'center', vertical: 'top' },
                                    type: { style: 'success', icon: true },
                                    hideAfter: 2000
                                });
                            }
                            else {
                                this.notificationService.show({
                                    appendTo: this.container,
                                    content: res.message,
                                    animation: { type: 'slide', duration: 500 },
                                    position: { horizontal: 'center', vertical: 'top' },
                                    type: { style: 'error', icon: true },
                                    hideAfter: 4000
                                });
                            }
                        }).
                        catch(err => {
                        });
                } else {
                    this.formValue.modulos = this.formValue.modulos.filter((obj) => { return obj.internalID !== m.internalID; });
                    this.gridView = this.formValue.modulos;
                }
            }
        });
    }

    public addModulo(): void {
        var m = {
            id: 0,
            refArmario: this.formValue.id,
            nomeArmario: '',
            refModeloModulo: 0,
            nomeModeloModulo: '',
            megaLocker: false,
            enderecoPrincipal: 0,
            internalID: this.formValue.modulos.length + 1
        };
        this.EditModulo(m)
    }

    public EditModulo(m: ModuloArmario): void {
        //  var idx= this.formValue?.modulos.findIndex((obj => obj. == data.refModeloModulo));
        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('modulos'),// this.customMsgService.translate('Modulos') ,
            // Show component
            content: ModulesFormComponent,
            //  actions: [{ text: "Adicionar" },],
        });
        const userInfo = dialogRef.content.instance as ModulesFormComponent;
        userInfo.formValue = m;
        userInfo.listItems2 = this.formValue?.modulos.map(x => x.refModeloModulo);
        dialogRef.result.subscribe((result) => {
            // if(result.save)  save
            var r = result as any;
            if (r.save) {
                this.formGroup.markAsDirty();
                var data = r.data as ModuloArmario;
                if (data.id == 0) {
                    var idx = this.formValue?.modulos.findIndex((obj => obj.refModeloModulo == data.refModeloModulo));
                    if (data.refModeloModulo == 1 && idx != -1) {
                        this.notificationService.show({
                            appendTo: this.container,
                            content: this.customMsgService.translate('naoPossivelMaisQueUmModuloPrincipal'),
                            animation: { type: 'slide', duration: 500 },
                            position: { horizontal: 'center', vertical: 'top' },
                            type: { style: 'error', icon: true },
                            hideAfter: 4000
                        });
                        return;
                    }
                    this.formValue?.modulos.push(data);
                }
                else {
                    const objIndex = this.formValue?.modulos.findIndex((obj => obj.id == data.id));
                    this.formValue.modulos[objIndex].refModeloModulo = data.refModeloModulo;
                    this.formValue.modulos[objIndex].nomeModeloModulo = data.nomeModeloModulo;
                    this.formValue.modulos[objIndex].megaLocker = data.megaLocker;
                }
                this.gridView = this.formValue?.modulos;
            }
        });
    }
}
